import { getEnvironment, getOptions } from './environment';
import { Tag } from './tag';

export enum DEBUG_PLUGIN_EVENTS {
  new = 'tag-new',
  fail = 'tag-load-fail',
  load = 'tag-load',
}

export const debugPluginMessage = (
  event: DEBUG_PLUGIN_EVENTS,
  payload: {
    _id: string;
    err?: unknown;
    campaignId?: string;
    clazz?: unknown;
    tagId?: string;
    version?: string;
    iframe?: boolean;
    amp?: boolean;
    mraid?: boolean;
    safeframe?: boolean;
    friendly?: boolean;
    endpoint?: string;
  },
) => {
  window.top?.postMessage(
    JSON.stringify({ type: 'mobkoi-debug-plugin', msg: { event, payload } }),
    '*',
  );
};

/**
 * Make debug plugin aware of new tag
 */
export const debugPluginNewTag = (tag: Tag) => {
  const environment = getEnvironment();
  const options = getOptions();

  debugPluginMessage(DEBUG_PLUGIN_EVENTS.new, {
    _id: tag._id,
    tagId: tag.tagId,
    version: options.version,
    iframe: environment.isIframe,
    amp: environment.isAmp,
    mraid: environment.mraid,
    safeframe: !!environment.safeFrame,
    friendly: !environment.isUnfriendly,
    endpoint: options.endpoint,
  });
};
